import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import CustomTabs from "components/Shared/CustomTabs";
import CustomTabPanel from "components/Shared/CustomTabPanel";
import RowsSkeleton from "components/Shared/Skeleton/RowsSkeleton";

import { ContractorShipmentList } from "./ContractorShipmentList";
import { useContractorDetailContext } from "contexts/ContractorDetailContext";
import { useLazyListContractorPricesQuery, useLazyListContractorShipmentsQuery } from "store/services/contractorApi";
import ContractorPriceList from "./ContractorPriceList";

const ContractorDetailTab = () => {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "shipment";
  const { vendorProfileDetail, loadingVendorProfileDetail } =
    useContractorDetailContext();

  const [fetchShipments, { data: shipmentRes, isLoading: isLoadingShipments, isFetching: isFetchingShipments }] =
    useLazyListContractorShipmentsQuery();

  const [fetchPricings, { data: pricingRes, isLoading: isLoadingPricings, isFetching: isFetchingPricings }] =
    useLazyListContractorPricesQuery();

  useEffect(() => {
    if (!vendorProfileDetail?._id) return;

    fetchShipments({
      vendorId: vendorProfileDetail._id,
      page: 1,
      limit: 1,
    });

    fetchPricings({
      vendorId: vendorProfileDetail._id,
      page: 1,
      limit: 1,
    });
  }, [vendorProfileDetail?._id, fetchShipments, fetchPricings]);

  const tabs = [
    {
      label: "Shipment",
      value: "shipment",
      badgeCount: shipmentRes?.totalItems || 0,
    },
    {
      label: "Pricing",
      value: "price",
      badgeCount: pricingRes?.totalItems || 0,
    },
  ];

  // Ensure activeTab is valid
  const validTabs = tabs.map((tab) => tab.value);
  const validatedActiveTab = validTabs.includes(activeTab) ? activeTab : "shipment";

  return (
    <>
      <CustomTabs tabs={tabs} activeTab={validatedActiveTab} />
      {loadingVendorProfileDetail ||
        isLoadingShipments ||
        isFetchingShipments ||
        isLoadingPricings ||
        isFetchingPricings ? (
        <RowsSkeleton />
      ) : (
        <>
          <CustomTabPanel activeTab={validatedActiveTab} value="shipment">
            <ContractorShipmentList />
          </CustomTabPanel>
          <CustomTabPanel activeTab={validatedActiveTab} value="price">
            <ContractorPriceList />
          </CustomTabPanel>
        </>
      )}
    </>
  );
};

export default ContractorDetailTab;